import React, { useState, useEffect } from 'react';
import './App.css';
import TaxiMap from './components/TaxiMap.jsx';
import TaxiInfo from './components/TaxiInfo.jsx';
import axios from 'axios';

function App({ tripId }) {
  const [tripData, setTripData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTripData = async () => {
      try {
        // Use the tripId from URL parameters for the API call
        const response = await axios.get(`https://taxi-api.lezzoodevs.com/api/taxi/trip-track-rider?tripKey=${tripId}`);
        
        // For now, using dummy data but would normally use the tripId in the API call
        if(response.data && response.data.success ){
          setTripData(response.data);
        }else{
          setTripData(null);
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching trip data:', err);
        // Use dummy data if API fails
        setTripData(null);
        setLoading(false);
      }
    };

    fetchTripData();
    // Poll for updates every 10 seconds
    const interval = setInterval(fetchTripData, 10000);
    return () => clearInterval(interval);
  }, [tripId]); // Add tripId as a dependency to re-fetch when it changes

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-content">
          <div className="logo-container">
            <img 
              src="https://lezzoo.com/images/Group.png" 
              alt="Lezzoo" 
              className="logo" 
            />
          </div>
        </div>
      </header>
      
      {loading || !tripData ? (
        <div className="app-content loading-state">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <div className="loading-text">Loading your trip details...</div>
          </div>
        </div>
      ) : (
        <div className="app-content">
          <div className="left-panel">
            <div className="info-container">
              <TaxiInfo 
                driver={tripData.rider_info} 
                tripDetails={tripData.trip_details} 
                status={tripData.trip_status} 
              />
            </div>
          </div>
          <div className="right-panel">
            <div className="trip-status-header">
              <div className="status-container">
                <h2 className="status-title">STATUS</h2>
                <div className="status-value">{tripData.trip_status_description}</div>
              </div>
            </div>
            <div className="map-container">
              <TaxiMap 
                driver={tripData.rider_info} 
                tripDetails={tripData.trip_details} 
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
